import { faListUl, faUserFriends } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import GuestsVisitsReportEmployee from "../../employee/GuestsVisitsReport";
import NotificationInPortsEmployee from "../../employee/NotificationsInPorts";

const useNavLinksArray = () => {
  const { t } = useTranslation();
  const navLinksArrayEmployee: navLinksArrayTimeWorkerInterface = {
    profileId: 11,
    routesArrayWithComponents: [
      {
        icon: faUserFriends,
        name: t("notifications"),
        ifHidden: false,
        singleLink: true,
        path: "/employee/home",
        component: () => <NotificationInPortsEmployee />,
      },
      {
        icon: faListUl,
        name: t("visits_report"),
        ifHidden: false,
        singleLink: true,
        path: "/employee/visits-report",
        component: () => <GuestsVisitsReportEmployee />,
      },
    ],
  };

  return navLinksArrayEmployee;
};
export default useNavLinksArray;
